<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="checklistitemitem_name" [(ttModel)]="edit.checklistitemitem_name"></tt-input>
        <tt-input-number ttLabel="checklistitemitem_order" [(ttModel)]="edit.checklistitemitem_order" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-input ttLabel="checklistitemitem_code" [(ttModel)]="edit.checklistitemitem_code"></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
